import type { useHomeFilter } from "../../../../hooks/useHomeFilter.ts";
import { useGetApiAssetsadvertAdvertisements, } from "../../../../api/rest/generated/assets-advert/assets-advert.ts";
import { useMemo } from "react";

export const useAllAds = (parsedFilter: ReturnType<typeof useHomeFilter>['parsedFilter']) => {
  const allAds = useGetApiAssetsadvertAdvertisements({
    AssetsCategoryId: parsedFilter.AssetsCategoryId
  });
  const result = useMemo(() => allAds.data?.data || [], [ allAds.data?.data ]);

  return {
    result,
    query: allAds,
  };
}